<div [ngClass]="isNewProductSelectorTemplateEnabled ? 'font' : ''">
  <div class="row m-t-xl">
    <h3 *ngIf="!isNewProductSelectorTemplateEnabled" class="col-6">
      {{ byodDeviceAemContent?.device }}
    </h3>
    <p *ngIf="isNewProductSelectorTemplateEnabled" class="col-6 device-heading">
      {{ byodDeviceAemContent?.device }}
    </p>
    <p
      class="col-6 text-end"
      [ngClass]="isNewProductSelectorTemplateEnabled ? 'device-heading-lead' : 'lead'"
    >
      <button
        attr.aria-label="{{ byodDeviceAemContent?.edit }}"
        (click)="editByodDevice()"
        id="cta-edit-8"
      >
        {{ byodDeviceAemContent?.edit }}
      </button>
    </p>
  </div>

  <div class="row center-align px-2">
    <div
      *ngIf="focusedTileIdDetails?.byodCMMOrImei?.imei"
      class="col-3 col-md-2 col-lg-2 m-t-lg xs-m-t-0 sm-m-t-0"
    >
      <div class="row">
        <div class="col-sm-12 text-center p-l-xs">
          <img
            id="no-image"
            class="img-fluid inline-block"
            src="{{ byodDeviceAemContent?.simImageUrl }}"
            alt="FPO Image"
          />
        </div>
      </div>
    </div>
    <div
      [ngClass]="focusedTileIdDetails?.byodCMMOrImei?.imei ? 'col-9 col-md-10 p-0' : 'col-12'"
      class="m-t-lg xs-m-t-sm sm-m-t-md"
    >
      <div class="row">
        <div class="col-12">
          <p
            *ngIf="isNewProductSelectorTemplateEnabled && focusedTileIdDetails?.byodCMMOrImei?.imei"
            class="mb-2 device-heading"
          >
            {{ byodDeviceAemContent?.yourDevice }}
          </p>
          <p
            *ngIf="imeiNumber === notApplicableConstant"
            [ngClass]="isNewProductSelectorTemplateEnabled ? 'title' : 'lead bold'"
          >
            {{ byodDeviceAemContent?.device }}:
            {{ byodDeviceAemContent?.compatibilityCheckSkipped }}
          </p>
          <h3
            *ngIf="!(imeiNumber === notApplicableConstant) && !isNewProductSelectorTemplateEnabled"
            class="lead bold"
          >
            {{ byodDeviceAemContent?.imeiLabel }} {{ imeiNumber }}
          </h3>
          <p
            *ngIf="!(imeiNumber === notApplicableConstant) && isNewProductSelectorTemplateEnabled"
            class="title"
          >
            {{ byodDeviceAemContent?.imeiLabel }} {{ imeiNumber }}
          </p>
          <ng-container *ngIf="SKUNumber; else iHaveSim">
            <p
              class="m-t-sm m-b-sm"
              [ngClass]="isNewProductSelectorTemplateEnabled ? 'title' : 'lead bold'"
              *ngIf="simDescription"
            >
              {{ simDescription | titlecase }}
            </p>
            <p
              [ngClass]="isNewProductSelectorTemplateEnabled ? 'title-small' : 'small'"
              *ngIf="simNumber"
            >
              {{ byodDeviceAemContent?.SIM }}: {{ simNumber }}
            </p>
            <p [ngClass]="isNewProductSelectorTemplateEnabled ? 'title-small' : 'small'">
              {{ byodDeviceAemContent?.sku }}: {{ SKUNumber }}
            </p>
            <p [ngClass]="isNewProductSelectorTemplateEnabled ? 'title-small' : 'small'">
              {{ pricing | dollarAmount }} {{ byodDeviceAemContent?.uponActivation }}
            </p>
          </ng-container>
          <ng-template #iHaveSim>
            <ng-container *ngIf="eid">
              <p class="m-t-sm small" *ngIf="!isNewProductSelectorTemplateEnabled">
                {{ byodDeviceAemContent?.eid }}: {{ eid }}
              </p>
              <p class="m-t-sm title-small" *ngIf="isNewProductSelectorTemplateEnabled">
                {{ byodDeviceAemContent?.eid }}<br />{{ eid }}
              </p>
            </ng-container>
            <p
              class="m-t-sm"
              [ngClass]="isNewProductSelectorTemplateEnabled ? 'title-small' : 'small'"
              *ngIf="simNumber && !eid"
            >
              {{ byodDeviceAemContent?.simNumber }} <br />{{ simNumber }}
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<hr class="divider m-t-xl" />
